import * as basicLightbox from "basiclightbox";
import { endlessPaginate } from "endless_pagination/endless-pagination-module.js";
import textFieldEdit from "text-field-edit";
import Tribute from "tributejs";
import {
	formAddCsrfProtection,
	getCsrfToken,
	getUrlParam,
	isMobile,
	updateGAdataLayer,
} from "../../common/utils.js";
import domFader from "./dom-fader.js";
import domSlider from "./dom-slider.js";

class MpCommentError extends Error {
	constructor(...params) {
		super(...params);
		this.name = "MpCommentError";
	}
}

export class MpComments {
	constructor() {
		this.commentsContainer = document.querySelector("#comments_container");
		this.page_param = "comment_page";
		this.hash_prefix = "#comment_c";
		this.is_bot =
			/alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/i.test(
				navigator.userAgent,
			);
	}

	_initEmoji() {
		for (const el of document.querySelectorAll("._emoji_show")) {
			el.addEventListener("click", (e) => {
				e.preventDefault();
				const target = e.target;
				if (target.classList.contains("active")) {
					target.classList.remove("active");
					target.nextElementSibling.classList.add("d-none");
				} else {
					target.classList.add("active");
					target.nextElementSibling.classList.remove("d-none");
				}
			});
		}

		for (const el of document.querySelectorAll("._emoji_container")) {
			for (const img of document.querySelectorAll(`#${el.id} img`)) {
				img.addEventListener("click", (e) => {
					const emoji = e.target.parentNode.dataset.name;
					if (emoji) {
						const textareaContainer = e.target.closest(".comments__textarea");
						const textarea = textareaContainer.querySelector("textarea");
						textFieldEdit.insert(
							textarea,
							` ${e.target.parentNode.dataset.name} `,
						);
					}
				});
			}
		}
	}

	// Textarea
	_initTextarea(values) {
		return new Promise((resolve) => {
			// Mentions
			const tribute = new Tribute({
				values: (term, cb) => {
					remoteSearch(term, (users) => cb(users));
				},
				lookup: "label",
				fillAttr: "value",
				selectTemplate: (item) => {
					return `[m]${item.original.label}[/m] `;
				},
				noMatchTemplate: () =>
					'<span class="text-danger d-block font-weight-bold p-2">Non ci sono risultati!</span>',
				menuShowMinLength: 2,
			});

			const remoteSearch = (term, cb) => {
				fetch(`/comments/mention/?term=${term}`, {
					headers: {
						"X-Requested-With": "XMLHttpRequest",
					},
				})
					.then((response) => response.json())
					.then((data) => {
						cb(data);
					})
					.catch((error) => {
						console.warn(error);
					});
			};
			tribute.attach(document.querySelectorAll(".comments__textarea textarea"));

			// Emoji
			this._initEmoji();

			// bbcode
			for (const el of document.querySelectorAll(
				".comments__textarea__buttons__insert__button",
			)) {
				el.addEventListener("click", (event) => {
					const target = event.currentTarget;
					event.preventDefault();
					const editor = target
						.closest(".comments__textarea")
						.querySelector("textarea");
					setTimeout(() => {
						editor.focus();
						textFieldEdit.wrapSelection(
							editor,
							target.dataset.openingTag,
							target.dataset.closingTag,
						);
					}, 100);
				});
			}

			// spoiler
			this.commentsContainer.addEventListener("click", (event) => {
				const target = event.target;
				if (target.classList.contains("bb-spoiler-toggle")) {
					const spoiler = target.parentNode.querySelector(
						".bb-spoiler-content",
					);
					if (!spoiler.classList.contains("d-none")) {
						target.textContent = "Mostra spoiler";
					} else {
						target.textContent = "Nascondi spoiler";
					}
					spoiler.classList.toggle("d-none");
				}
			});

			// Reply
			if (
				!!document.querySelector("#login_registration_container") &&
				!!document.querySelector("#user_nav #_user_panel_container") === false
			) {
				// Handling the login window when the user is not logged in for replies
				if (document.querySelectorAll("#comments_container a.reply").length) {
					window.globalLoginWindowHandler.commentAnswerLogin(
						document.querySelectorAll(
							"#comments_container:not(.already-logged-in) a.reply",
						),
					);
				}
			} else {
				const _replyHandler = (event) => {
					const target = event.target;
					if (target.classList.contains("reply")) {
						event.stopImmediatePropagation();
						event.preventDefault();
						const commentContainer = target.closest(".comment");
						const templateForm = document.querySelector(
							"#template-comment-form",
						);
						const parentField = templateForm.querySelector(
							`input[name="${templateForm.dataset.prefix}-parent"]`,
						);
						const editor = templateForm.querySelector("textarea");
						const replyTo = target.dataset.user;
						// form template gia' posizionato
						if (parentField.value === commentContainer.dataset.id) {
							if (
								templateForm.classList.contains("closed") ||
								templateForm.classList.contains("d-none")
							) {
								domSlider
									.slideDown(templateForm, { duration: 400 })
									.then(() => {
										templateForm.classList.remove("d-none");
										editor.focus();
									});
							}
							return;
						}
						// form template da posizionare e inizializzare
						parentField.value = commentContainer.dataset.id;
						editor.value = "";
						commentContainer.appendChild(templateForm);
						domSlider.slideDown(templateForm, { duration: 400 }).then(() => {
							templateForm.classList.remove("d-none");
							editor.focus();
							if (replyTo) {
								textFieldEdit.insert(editor, `[m]${replyTo}[/m] `);
							}
						});
					}
				};
				this.commentsContainer.addEventListener("click", _replyHandler);
				const removeReplyEvent = () => {
					this.commentsContainer.removeEventListener("click", _replyHandler);
				};
				window.globalLoginWindowHandler.anonymousClicks.push(removeReplyEvent);
			}

			// status di default delle textarea
			for (const formContainer of document.querySelectorAll(
				".comments__textarea",
			)) {
				// funzionalità non presenti in modifica commento
				if (!formContainer.classList.contains("_edit-comment")) {
					const textarea = formContainer.querySelector("textarea");
					textarea.style.height = "38px";
					for (const buttonContainer of formContainer.querySelectorAll(
						".comments__textarea__buttons",
					)) {
						buttonContainer.classList.add("d-none");
					}
					formContainer.classList.add("closed");

					// textarea focus
					if (
						!!document.querySelector("#login_registration_container") &&
						!!document.querySelector("#user_nav #_user_panel_container") ===
							false
					) {
						// Handling the login window when the user is not logged in for comment forms (top and bottom)
						if (
							textarea.id === "id_top-comment" ||
							textarea.id === "id_bottom-comment"
						) {
							window.globalLoginWindowHandler.commentTextareaLogin([textarea]);
						}
					} else {
						textarea.addEventListener("focus", (event) => {
							const target = event.currentTarget;
							const parentContainer = target.closest(".comments__textarea");

							if (parentContainer.classList.contains("closed")) {
								parentContainer.classList.remove("closed");
								parentContainer.querySelector("textarea").style.height = "8em";
								// L'altezza del top comment form viene data a mano altrimenti il permalink sul commento non funziona correttamente
								if (document.querySelector("#_top-comment-container")) {
									document.querySelector(
										"#_top-comment-container",
									).style.height = "auto";
								}
								for (const buttonContainer of parentContainer.querySelectorAll(
									".comments__textarea__buttons",
								)) {
									buttonContainer.classList.remove("d-none");
									domSlider.slideDown(buttonContainer);
								}
							}
						});
					}

					// pulsante "annulla"
					if (formContainer.querySelector(".cancel")) {
						formContainer
							.querySelector(".cancel")
							.addEventListener("click", (event) => {
								const target = event.currentTarget;
								const parentContainer = target.closest(".comments__textarea");

								if (parentContainer.id === "template-comment-form") {
									domSlider
										.slideUp(parentContainer, { duration: 400 })
										.then((isOpen) => {
											parentContainer.classList.add("d-none", "closed");
											parentContainer.querySelector("textarea").style.height =
												"38px";

											for (const buttonContainer of parentContainer.querySelectorAll(
												".comments__textarea__buttons",
											)) {
												domSlider
													.slideUp(buttonContainer, { duration: 400 })
													.then(() => {
														buttonContainer.classList.add("d-none");
													});
											}
										});
								} else if (!parentContainer.classList.contains("closed")) {
									parentContainer.classList.add("closed");
									parentContainer.querySelector("textarea").value = "";
									parentContainer.querySelector("textarea").style.height =
										"38px";
									if (document.querySelector("#_top-comment-container")) {
										document.querySelector(
											"#_top-comment-container",
										).style.height = "auto";
									}

									for (const buttonContainer of parentContainer.querySelectorAll(
										".comments__textarea__buttons",
									)) {
										domSlider
											.slideUp(buttonContainer, { duration: 400 })
											.then(() => {
												buttonContainer.classList.add("d-none");
											});
									}
								}
							});
					}
				}
				formContainer.style.visibility = "visible";
			}
			resolve("textarea ready!");
		});
	}

	//  Event handlers
	_eventListeners(result) {
		console.log(result);
		return new Promise((resolve, reject) => {
			// Paginazione
			endlessPaginate({
				moreSelector: "span.endless_more",
				moreSelectorDataUrl: "data-more",
				onCompleted: (context, fragment) => {
					if (
						context.url.includes("replies") &&
						!!document.querySelector("#login_registration_container") &&
						!!document.querySelector("#user_nav #_user_panel_container") ===
							false
					) {
						// Handling the login window when the user is not logged in for comment votes
						if (
							document.querySelectorAll("#comments_container .comment .like")
								.length
						) {
							window.globalLoginWindowHandler.commentVoteLogin(
								document.querySelectorAll("#comments_container .comment .like"),
							);
						}
						// Handling the login window when the user is not logged in for comment forms
						if (
							document.querySelectorAll("#comments_container a.reply").length
						) {
							window.globalLoginWindowHandler.commentAnswerLogin(
								document.querySelectorAll(
									"#comments_container:not(.already-logged-in) a.reply",
								),
							);
						}
					}
				},
			});

			// Post comment
			for (const el of document.querySelectorAll("._comment_submit")) {
				el.addEventListener("click", (event) => {
					event.preventDefault();
					const button = event.currentTarget;
					const form = button.closest("form.comment-form");
					this.commentsContainer.classList.add("loading");
					button.setAttribute("disabled", true);
					formAddCsrfProtection(form).then((data) => {
						const formData = new FormData(form);
						fetch(form.getAttribute("action"), {
							headers: {
								"X-Requested-With": "XMLHttpRequest",
							},
							method: "POST",
							cache: "no-cache",
							body: formData,
						})
							.then((response) => {
								if (!response.ok) {
									if (response.status === 403) {
										return response.text().then((error_text) => {
											throw new MpCommentError(
												error_text ||
													"Non è stato possibile salvare il tuo commento",
											);
										});
									}
									throw new MpCommentError(
										"Non è stato possibile salvare il tuo commento",
									);
								}
								return response.text();
							})
							.then((data) => {
								// GA4
								updateGAdataLayer("comment_submit");
								const redirectTo = new URL(data, window.location.origin);
								window.location.assign(redirectTo);
								const timeoutID = setTimeout(() => {
									clearTimeout(timeoutID);
									window.location.reload();
									this.commentsContainer.classList.remove("loading");
								}, 1000);
							})
							.catch((error) => {
								if (error.name === "MpCommentError") {
									this.commentsContainer.classList.remove("loading");
									const error_message =
										document.querySelector("#_error_message");
									error_message.innerHTML = error.message;
									error_message.classList.add("alert--sticky");
									error_message.classList.remove("d-none");
									button.setAttribute("disabled", false);
									const timeoutID = setTimeout(() => {
										clearTimeout(timeoutID);
										error_message.classList.remove("alert--sticky");
									}, 5000);
								} else {
									console.warn(" --- Error: ", error);
								}
							});
					});
				});
			}

			// Ordinamento
			if (document.querySelector("#_order_by")) {
				document
					.querySelector("#_order_by")
					.addEventListener("change", (event) => {
						const searchParams = new URLSearchParams(window.location.search);
						searchParams.set("order_by", event.target.value);
						if (window.location.hash === "") {
							window.location.hash = "#comments_container";
						}
						window.location.search = searchParams.toString();
					});
			}

			// Score
			if (
				!!document.querySelector("#login_registration_container") &&
				!!document.querySelector("#user_nav #_user_panel_container") === false
			) {
				// Handling the login window when the user is not logged in for comment votes
				if (
					document.querySelectorAll("#comments_container .comment .like").length
				) {
					window.globalLoginWindowHandler.commentVoteLogin(
						document.querySelectorAll("#comments_container .comment .like"),
					);
				}
			} else {
				const _scoreHandler = (event) => {
					const target = event.target;
					if (target.classList.contains("like")) {
						event.preventDefault();
						const commentContainer = target.closest(".comment");

						// Promoted comments cannot be voted
						if (commentContainer.classList.contains("promoted")) {
							return false;
						}

						getCsrfToken().then((token) => {
							if (token) {
								const formData = new FormData();
								formData.append("csrfmiddlewaretoken", token);
								formData.append("post_id", target.dataset.post);
								fetch(target.href, {
									headers: {
										"X-Requested-With": "XMLHttpRequest",
									},
									method: "POST",
									body: formData,
								})
									.then((response) => {
										if (!response.ok) {
											return response.text().then((error_text) => {
												throw new MpCommentError(
													error_text || "Impossibile votare",
												);
											});
										}
										return response.text();
									})
									.then((data) => {
										// If the user is banned
										if (data == null) {
											return;
										}

										// GA4
										const reactionType = target.classList.contains("up")
											? "like"
											: "dislike";
										updateGAdataLayer(
											"reaction_submit",
											"reaction_type",
											reactionType,
										);

										const scoreContainer =
											commentContainer.querySelector(".score");
										const score = Number.parseInt(data);
										let otherLikeButton = Array.prototype.filter.call(
											target.parentNode.children,
											(sibling) =>
												sibling !== target &&
												sibling.classList.contains("like"),
										);
										if (otherLikeButton.length) {
											otherLikeButton = otherLikeButton[0];
										}

										domFader
											.fadeOut(scoreContainer, {
												fadeSpeed: 400,
												easing: "easeIn",
											})
											.then((box) => {
												if (score > 0) {
													scoreContainer.classList.remove("bad");
													scoreContainer.classList.add("good");
												} else if (score < 0) {
													scoreContainer.classList.remove("good");
													scoreContainer.classList.add("bad");
												} else {
													scoreContainer.classList.remove("good", "bad");
												}
												scoreContainer.querySelector("span").textContent =
													String(score).replace("-", "");
												domFader.fadeIn(box, {
													fadeSpeed: 400,
													easing: "easeOut",
												});
											});

										if (target.classList.contains("active")) {
											target.classList.remove("active");
										} else if (otherLikeButton.classList.contains("active")) {
											otherLikeButton.classList.remove("active");
										} else {
											target.classList.add("active");
										}
									})
									.catch((error) => {
										if (error.name === "MpCommentError") {
											const error_message =
												document.querySelector("#_error_message");
											error_message.innerHTML = error.message;
											error_message.classList.add("alert--sticky");
											error_message.classList.remove("d-none");
											const timeoutID = setTimeout(() => {
												clearTimeout(timeoutID);
												error_message.classList.remove("alert--sticky");
											}, 5000);
										} else {
											console.warn(" --- Error: ", error);
										}
									});
							}
						});
					}
				};
				this.commentsContainer.addEventListener("click", _scoreHandler);
				const removeScoreEvent = () => {
					this.commentsContainer.removeEventListener("click", _scoreHandler);
				};
				window.globalLoginWindowHandler.anonymousClicks.push(removeScoreEvent);
			}

			// Notifiche
			const _notificationHandler = (event) => {
				const target = event.target;
				if (target.classList.contains("block_comment_notification")) {
					getCsrfToken().then((token) => {
						if (token) {
							const formData = new FormData();
							formData.append("csrfmiddlewaretoken", token);
							fetch(target.dataset.url, {
								headers: {
									"X-Requested-With": "XMLHttpRequest",
								},
								method: "POST",
								body: formData,
							})
								.then((response) => response.text())
								.catch((error) => {
									console.warn(" --- Error: ", error);
								});
						}
					});
				}
			};
			this.commentsContainer.addEventListener("click", _notificationHandler);
			const removeNotificationEvent = () => {
				this.commentsContainer.removeEventListener(
					"click",
					_notificationHandler,
				);
			};
			window.globalLoginWindowHandler.anonymousClicks.push(
				removeNotificationEvent,
			);

			// Commenti nascosti
			if (document.querySelectorAll("._bl_comment").length) {
				document
					.querySelector("#_bl_comments_alert")
					.classList.remove("d-none");
				document
					.querySelector("#_bl_comments_show")
					.addEventListener("click", (event) => {
						for (const el of document.querySelectorAll("._bl_comment")) {
							el.classList.remove("d-none");
						}
						document
							.querySelector("#_bl_comments_alert")
							.classList.add("d-none");
					});
			}

			resolve("event listeners attached!");
		});
	}

	// Moderators only / special permissions
	_modTools(result) {
		console.log(result);
		return new Promise((resolve, reject) => {
			// Moderators menu
			if (document.querySelectorAll("._mod-menu").length) {
				// Reset punteggio commento
				const _resetScoreHandler = (event) => {
					const target = event.target;
					if (
						target.classList.contains("comments__textarea__buttons__resetscore")
					) {
						event.preventDefault();
						const commentContainer = target.closest(".comment");
						fetch(target.href, {
							headers: {
								"X-Requested-With": "XMLHttpRequest",
							},
						})
							.then((response) => {
								if (response.ok) {
									const scoreContainer =
										commentContainer.querySelector(".score");
									scoreContainer.querySelector("span").textContent = "0";
									scoreContainer.classList.remove("good", "bad");
									for (const el of commentContainer.querySelectorAll(".like")) {
										el.classList.remove("active", "disabled");
									}
								} else {
									throw new MpCommentError(
										"Impossibile resettare il punteggio",
									);
								}
							})
							.catch((error) => {
								console.warn(" --- Error: ", error);
							});
					}
				};
				this.commentsContainer.addEventListener("click", _resetScoreHandler);
				const removeResetScoreEvent = () => {
					this.commentsContainer.removeEventListener(
						"click",
						_resetScoreHandler,
					);
				};
				window.globalLoginWindowHandler.anonymousClicks.push(
					removeResetScoreEvent,
				);

				// Blocca discussione
				const _blockDiscussionHandler = (event) => {
					const target = event.target;
					if (target.classList.contains("block_unblock_discussion")) {
						event.preventDefault();
						const commentContainer = target.closest(".comment");
						const unblock = target.textContent.trim() === "Sblocca discussione";
						getCsrfToken().then((token) => {
							if (token) {
								const formData = new FormData();
								formData.append("csrfmiddlewaretoken", token);
								fetch(target.href, {
									headers: {
										"X-Requested-With": "XMLHttpRequest",
									},
									method: "POST",
									body: formData,
								})
									.then((response) => {
										if (response.ok) {
											const message = unblock
												? target.dataset.unblockMessage
												: target.dataset.blockMessage;
											if (
												commentContainer.querySelector("#discussion_blocked")
											) {
												commentContainer.querySelector(
													"#discussion_blocked",
												).textContent = message;
											} else {
												commentContainer.insertAdjacentHTML(
													"beforeend",
													`<div class="alert alert-danger fade" role="alert" id="discussion_blocked">${message}</div>`,
												);
											}
											if (unblock) {
												target.textContent = "Blocca discussione";
											} else {
												target.textContent = "Sblocca discussione";
											}
											document
												.querySelector(`.${target.dataset.toggleBlockIcon}`)
												.setAttribute("hidden", unblock);
										} else {
											const message = unblock
												? "Impossibile sbloccare la discussione"
												: "Impossibile bloccare la discussione";
											throw new MpCommentError(message);
										}
									})
									.catch((error) => {
										console.warn(" --- Error: ", error);
									});
							}
						});
					}
				};
				this.commentsContainer.addEventListener(
					"click",
					_blockDiscussionHandler,
				);
				const removeBlockDiscussionEvent = () => {
					this.commentsContainer.removeEventListener(
						"click",
						_blockDiscussionHandler,
					);
				};
				window.globalLoginWindowHandler.anonymousClicks.push(
					removeBlockDiscussionEvent,
				);

				// Ban / ammonizione
				const _infringementHandler = (event) => {
					const target = event.target;
					if (
						target.classList.contains(
							"comments__textarea__buttons__addinfringement",
						)
					) {
						event.preventDefault();
						const commentContainer = target.closest(".comment");
						const infringementLightbox = basicLightbox.create(
							document.querySelector("#infringement_form_wrapper").innerHTML,
							{
								onShow: (instance) => {
									const infringementContainer = instance.element();
									const form =
										infringementContainer.querySelector(".infringement-form");
									form.querySelector("#id_typology").value =
										target.dataset.typology;
									form.querySelector("#id_comment").value =
										commentContainer.dataset.id;
									if (target.dataset.typology === "warning") {
										infringementContainer.querySelector(
											"._infringement_type_title",
										).textContent = "Ammonisci";
										form
											.querySelector("._expiration_label")
											.classList.add("d-none");
										form
											.querySelector("#id_expiration")
											.classList.add("d-none");
									}
									form
										.querySelector("input._infringement-send")
										.addEventListener("click", (e) => {
											e.preventDefault();
											formAddCsrfProtection(form).then((data) => {
												const formData = new FormData(form);
												fetch(form.getAttribute("action"), {
													headers: {
														"X-Requested-With": "XMLHttpRequest",
													},
													method: "POST",
													cache: "no-cache",
													body: formData,
												})
													.then((response) => {
														if (response.ok) {
															instance.close();
															window.location.hash = `comment_c${commentContainer.dataset.id}`;
															this.loadComments();
														} else {
															instance.close();
															throw new MpCommentError(
																"Impossibile assegnare il ban/ammonizione",
															);
														}
													})
													.catch((error) => {
														console.warn(" --- Error: ", error);
													});
											});
										});
								},
							},
						);
						infringementLightbox.show();
					}
				};
				this.commentsContainer.addEventListener("click", _infringementHandler);
				const removeInfringementEvent = () => {
					this.commentsContainer.removeEventListener(
						"click",
						_infringementHandler,
					);
				};
				window.globalLoginWindowHandler.anonymousClicks.push(
					removeInfringementEvent,
				);

				// Cancella commento con motivazione
				const _deleteCommentHandler = (event) => {
					const target = event.target;
					if (
						target.classList.contains(
							"comments__textarea__buttons__deletecomment",
						)
					) {
						event.preventDefault();
						const commentContainer = target.closest(".comment");
						const deleteCommentLightbox = basicLightbox.create(
							document.querySelector("#deletion_form_wrapper").innerHTML,
							{
								onShow: (instance) => {
									const deletionContainer = instance.element();
									const form =
										deletionContainer.querySelector(".deletion-form");
									form
										.querySelector("input._delete-comment-button")
										.addEventListener("click", (e) => {
											e.preventDefault();
											e.currentTarget.setAttribute("disabled", true);
											formAddCsrfProtection(form).then((data) => {
												const formData = new FormData(form);
												fetch(target.href, {
													headers: {
														"X-Requested-With": "XMLHttpRequest",
													},
													method: "POST",
													cache: "no-cache",
													body: formData,
												})
													.then((response) => {
														if (response.ok) {
															instance.close();
															window.location.hash = `comment_c${commentContainer.dataset.id}`;
															this.loadComments();
														} else {
															instance.close();
															throw new MpCommentError(
																"Impossibile cancellare il commento",
															);
														}
													})
													.catch((error) => {
														console.warn(" --- Error: ", error);
													});
											});
										});
								},
							},
						);
						deleteCommentLightbox.show();
					}
				};
				this.commentsContainer.addEventListener("click", _deleteCommentHandler);
				const removeDeleteCommentEvent = () => {
					this.commentsContainer.removeEventListener(
						"click",
						_deleteCommentHandler,
					);
				};
				window.globalLoginWindowHandler.anonymousClicks.push(
					removeDeleteCommentEvent,
				);
			}

			// Discussione non moderata
			if (document.querySelector("#_non_moderated_discusion")) {
				document
					.querySelector("#_non_moderated_discusion")
					.addEventListener("change", (event) => {
						const target = event.currentTarget;
						getCsrfToken().then((token) => {
							if (token) {
								const formData = new FormData();
								formData.append("csrfmiddlewaretoken", token);
								fetch(target.dataset.url, {
									headers: {
										"X-Requested-With": "XMLHttpRequest",
									},
									method: "POST",
									body: formData,
								})
									.then((response) => {
										if (!response.ok) {
											target.checked = !target.checked;
											throw new MpCommentError(
												"Impossibile cambiare lo status della discussione",
											);
										}
									})
									.catch((error) => {
										console.warn(" --- Error: ", error);
									});
							}
						});
					});
			}

			// Delete comments
			const delete_button = document.querySelector("._delete_comments_button");
			if (delete_button) {
				delete_button.addEventListener("click", (event) => {
					event.preventDefault();
					this.commentsContainer.classList.add("loading");
					getCsrfToken().then((token) => {
						if (token) {
							const formData = new FormData();
							formData.append("csrfmiddlewaretoken", token);
							for (const el of document.querySelectorAll(
								'input[name="delete_comments"]:checked',
							)) {
								formData.append("delete_comments", el.value);
							}
							fetch(delete_button.dataset.url, {
								headers: {
									"X-Requested-With": "XMLHttpRequest",
								},
								method: "POST",
								body: formData,
							})
								.then((response) => {
									if (!response.ok) {
										return response.text().then((error_text) => {
											throw new MpCommentError(
												error_text ||
													"C'è stato un problema con la cancellazione",
											);
										});
									}
									this.loadComments();
								})
								.catch((error) => {
									if (error.name === "MpCommentError") {
										this.commentsContainer.classList.remove("loading");
										const error_message =
											document.querySelector("#_error_message");
										error_message.innerHTML = error.message;
										error_message.classList.add("alert--sticky");
										error_message.classList.remove("d-none");
										delete_button.setAttribute("disabled", true);
										const timeoutID = setTimeout(() => {
											clearTimeout(timeoutID);
											error_message.classList.remove("alert--sticky");
										}, 5000);
									} else {
										console.warn(" --- Error: ", error);
									}
								});
						}
					});
				});
			}

			const _selectToDeleteHandler = (event) => {
				const target = event.target;
				const comments = !!document.querySelectorAll(
					"._delete_comments:checked",
				).length;
				if (target.classList.contains("_delete_comments")) {
					document
						.querySelector("._delete_comments_button")
						.classList.toggle("d-none", !comments);
					target
						.closest(".comment")
						.classList.toggle("_comment_checked_to_delete", target.checked);
				}
			};
			this.commentsContainer.addEventListener("change", _selectToDeleteHandler);
			const removeSelectToDeleteEvent = () => {
				this.commentsContainer.removeEventListener(
					"change",
					_selectToDeleteHandler,
				);
			};
			window.globalLoginWindowHandler.anonymousClicks.push(
				removeSelectToDeleteEvent,
			);

			resolve("mod tools activated!");
		});
	}

	initComments() {
		console.log("initComments");
		return new Promise((resolve, reject) => {
			if (
				document.querySelectorAll("#comments_container .comment-form").length
			) {
				// TOOLTIP BOOTSTRAP
				if (
					!isMobile() &&
					document.querySelectorAll('[data-toggle="tooltip"]').length
				) {
					import("jquery").then((jQuery) => {
						const $ = jQuery.default;
						import("bootstrap/js/dist/tooltip").then(() => {
							$('#comments_container [data-toggle="tooltip"]').tooltip();
						});
					});
				}

				// Nascondo le textarea prima di inizializzarle e attivo loading
				for (const el of document.querySelectorAll(".comments__textarea")) {
					el.style.visibility = "hidden";
				}
				this.commentsContainer.classList.add("loading");

				this._initTextarea()
					.then((result) => this._eventListeners(result))
					.then((result) => this._modTools(result))
					.then((result) => {
						console.log(result);
						console.log("Init completed!");
						this.commentsContainer.classList.remove("loading");
						resolve(true);
					});
			} else {
				console.log("No comments to initialize!");
				resolve(false);
			}
		});
	}

	async _getComments() {
		console.log("_getComments");
		return await fetch(this.commentsContainer.dataset.url, {
			headers: {
				"X-Requested-With": "XMLHttpRequest",
			},
		})
			.then((response) => {
				if (response.ok) {
					return response.text();
				}
				throw new MpCommentError("Impossibile caricare i commenti");
			})
			.then((data) => {
				if (data) {
					this.commentsContainer.innerHTML = data;
					const templateForm = document.querySelector("#template-comment-form");
					if (templateForm) templateForm.classList.add("d-none");

					if (window.location.hash) {
						window.location.href = window.location.hash;
					}
					// aggiunge ancora commenti alla paginazione
					for (const el of this.commentsContainer.querySelectorAll(
						".pagination a",
					)) {
						const href = el.getAttribute("href");
						if (href.indexOf("#") === -1) {
							el.setAttribute("href", `${href}#comments_container`);
						}
					}
				}
			});
	}

	async _pickComment() {
		console.log("_pickComment");
		// Presente hash nell'URL: caricamento commento specifico
		if (
			window.location.hash &&
			window.location.hash.substring(0, this.hash_prefix.length) ===
				this.hash_prefix
		) {
			const comment_id = window.location.hash.substring(
				this.hash_prefix.length,
			);
			if (!document.querySelector(window.location.hash)) {
				const comment = await fetch(
					`/comments/pick/${comment_id}/?offset=5&per_page=100`,
					{
						headers: {
							"X-Requested-With": "XMLHttpRequest",
						},
					},
				).then((response) => {
					if (response.ok) {
						return response.json();
					}
					throw new MpCommentError("Impossibile fare il pick del commento");
				});
				return comment;
			}
			return new Promise((resolve) => resolve(comment_id));
		}
	}

	async _loadReplies(comment) {
		console.log("_loadReplies");
		if (comment) {
			const comment_id = window.location.hash.substring(
				this.hash_prefix.length,
			);

			const scroll_to = () => {
				const $comment = document.querySelector(`#comment_c${comment_id}`);
				$comment.classList.add("comment--target");
				let scrollValue;
				if (document.querySelector("#adv-head")) {
					scrollValue =
						$comment.offsetTop +
						document.querySelector("#header").offsetHeight +
						document.querySelector("#adv-head").offsetHeight;
				} else {
					let paddingTop = Number.parseInt(
						window.getComputedStyle(document.body).paddingTop,
					);
					if (Number.isNaN(paddingTop)) {
						paddingTop = 50;
					}
					scrollValue = $comment.offsetTop + paddingTop;
				}
				scroll({
					top: scrollValue,
					behavior: "smooth",
				});
			};

			if (typeof comment === "string") {
				scroll_to();
			} else {
				const regex = /[\?&]comment_page=([^&#]*)/;
				const params = regex.exec(location.search);
				const comment_page =
					params == null
						? "1"
						: decodeURIComponent(params[1].replace(/\+/g, " "));
				const url = `/comments/replies/${comment.parent}/?comment_page=${comment_page}&page=${comment.page}`;
				const $parent = document.querySelector(`#comment_c${comment.parent}`);
				const $more = document.querySelector(
					`.endless_more[data-more^="${url}"]`,
				);

				const replies = await fetch(url, {
					headers: {
						"X-Requested-With": "XMLHttpRequest",
					},
				})
					.then((response) => {
						if (response.ok) {
							return response.text();
						}
						throw new MpCommentError("Impossibile caricare le replies");
					})
					.then((replies) => {
						if (replies && $parent) {
							if ($more) {
								$more.parentNode.removeChild($more);
							}
							$parent.insertAdjacentHTML("afterend", replies);
							scroll_to();
						}
					});
				return replies;
			}
		}
	}

	loadComments() {
		const page_value = getUrlParam(this.page_param);
		if (page_value) {
			const data_url = this.commentsContainer.dataset.url;
			let separator = "";
			if (data_url.indexOf(this.page_param) === -1) {
				if (data_url.indexOf("?") === -1) separator = "?";
				else if (data_url[data_url.length - 1] !== "?") separator = "&";
				this.commentsContainer.dataset.url = `${data_url + separator + this.page_param}=${page_value}`;
			}
		}

		if (this.is_bot) {
			this.commentsContainer.parentNode.removeChild(this.commentsContainer);
		} else {
			this._getComments()
				.then(() => this._pickComment())
				.then((comment) => this._loadReplies(comment))
				.catch((error) => {
					console.warn("----- Loading => ", error);
				})
				.then(() => this.initComments())
				.then((result) => {
					if (result) {
						const commentsLoaded = new Event("commentsloaded");
						document.dispatchEvent(commentsLoaded);
						console.log("commentsloaded dispatched");
					}
				})
				.catch((error) => {
					console.warn("----- Initializing => ", error);
				});
		}
	}
}
